import React from 'react';

const CaseStudies = () => {
  const caseStudies = [
    {
      title: 'E-commerce Platform Migration',
      company: 'TechCorp Inc.',
      description: 'Successfully migrated a legacy e-commerce platform to AWS with zero downtime.',
      results: ['50% reduction in infrastructure costs', '99.9% uptime achieved', '3x faster deployment cycles'],
      image: '/images/cloud_migration.jpg'
    },
    {
      title: 'DevOps Transformation',
      company: 'FinTech Solutions',
      description: 'Implemented complete DevOps culture transformation for a financial services company.',
      results: ['80% faster time to market', '90% reduction in deployment failures', 'Improved team collaboration'],
      image: '/images/devoops-optimization.webp'
    },
    {
      title: 'Kubernetes Implementation',
      company: 'StartupXYZ',
      description: 'Designed and implemented Kubernetes infrastructure for a growing startup.',
      results: ['Auto-scaling capabilities', 'Improved resource utilization', 'Enhanced monitoring and alerting'],
      image: '/images/k8_expertise.webp'
    }
  ];

  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Case Studies
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real-world examples of how we've helped businesses achieve their DevOps and cloud goals
          </p>
        </div>
        
        <div className="space-y-12">
          {caseStudies.map((study, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="md:flex">
                <div className="md:w-1/3">
                  <img 
                    src={study.image} 
                    alt={study.title}
                    className="w-full h-64 md:h-full object-cover"
                  />
                </div>
                <div className="md:w-2/3 p-8">
                  <div className="flex items-center mb-4">
                    <h3 className="text-2xl font-bold text-gray-900">{study.title}</h3>
                    <span className="ml-4 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                      {study.company}
                    </span>
                  </div>
                  <p className="text-gray-600 mb-6">{study.description}</p>
                  <h4 className="font-semibold text-gray-900 mb-3">Key Results:</h4>
                  <ul className="space-y-2">
                    {study.results.map((result, resultIndex) => (
                      <li key={resultIndex} className="flex items-center">
                        <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                        {result}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Ready to Start Your Success Story?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Let's discuss how we can help you achieve similar results.
          </p>
          <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
            Get Started Today
          </button>
        </div>
      </div>
    </div>
  );
};

export default CaseStudies; 